import React from 'react';
import { Layout } from 'antd';
const { Footer: AntFooter } = Layout;
const Footer = () => {
    return (<AntFooter style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 20px', fontSize: 12, color: '#666' }}>
    </AntFooter>);
};
export default Footer;
